import { createApp } from 'vue'
import { router } from './router'
import App from './App.vue'
import { createPinia } from 'pinia'
import './assets/font/font-icon.css'
import './assets/style/main.scss'
import 'animate.css'
import 'nprogress/nprogress.css'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import myDirective from './utils/directive'
import { initGlobalScrollbar } from './utils/global-scrollbar'
import SvgIcon from './components/SvgIcon.vue'
import { setupAnalytics } from '@/utils/privacy-consent'
import 'virtual:svg-icons-register' // 注册 SVG 雪碧图（src/assets/icons）
import 'default-passive-events'
import '../src/utils/_lib-flexible.js'
import { preloadAnniversaryImages } from './views/home/components/anniversary/preload'

// 进入官网即后台预加载 9 周年庆弹窗切图，用户点击时秒开
preloadAnniversaryImages()
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
initGlobalScrollbar()

const app = createApp(App)
myDirective(app) //自定义指令
app.component('SvgIcon', SvgIcon) // 全局 SVG 图标组件
app.use(router).use(pinia)

// 已同意隐私政策的用户：恢复统计SDK（百度统计/ARMS）；未同意则不加载
setupAnalytics()

app.mount('#app')
app.config.errorHandler = (err, vm, info) => {
  console.error('Global Vue error---:', err, info)
}
